export enum FormDialogCloseReason {
  DELETE = 'delete',
  BACK = 'back',
  EXTRA = 'extra',
}
